import React from "react";
import { useTranslation } from "react-i18next";
import MainLayouts from "../layouts/MainLayouts";
import CoursesListSection from "../components/courses/CoursesListSection";
import CoursesLeftPanel from "../components/courses/CoursesLeftPanel";
import SimplePageHeader from "../components/SimplePageHeader";
import FilterDropdown from "../custom-components/filters/FilterDropdown";
import { useState } from "react";
import { useBreakpoint } from "../custom-hooks/useBreakpoint";

export default function Courses() {
    const { t } = useTranslation();
    const { isTablet, isMobile } = useBreakpoint();
    const [selectedTopics, setSelectedTopics] = useState([]);

    return (
        <MainLayouts pageTitle={t("courses.pageTitle")}>
            <div className="md:hidden w-full mx-auto mt-10 mb-[50px]">
                <h1 className="font-geologica text-2xl font-medium uppercase text-primary-400 mb-5">
                    {t("courses.pageTitle")}
                </h1>
              {/*   <FilterDropdown /> */}
                <div className="mt-10">
                    <CoursesListSection selectedTopics={selectedTopics} />
                </div>
            </div>

            <div className="hidden md:block lg:hidden mb-[32px]">
                <h1 className="font-geologica text-[36px] font-medium leading-[100%] uppercase text-primary-400 mb-[32px]">
                    {t("courses.pageTitle")}
                </h1>

                <div className="flex items-center gap-[24px] mb-[32px]">
                {/*    <span className="text-base text-text-300">{t("educationalMaterials.filters.sortBy")}</span>
                    <FilterDropdown /> */}
                </div>

                <div className="w-full max-w-[1280px] mx-auto mb-[100px]">
                    <CoursesListSection selectedTopics={selectedTopics} />
                </div>
            </div>

            <div className="hidden lg:block">
                <SimplePageHeader
                    title={t("courses.pageTitle")}
                    rightSlot={
                        <div className="flex items-center gap-[24px]">
                         {/*    <span className="text-base text-text-300">{t("educationalMaterials.filters.sortBy")}</span>
                           <FilterDropdown /> */}
                        </div>
                    }
                />
            </div>

            <div className="hidden lg:block w-full max-w-[1280px] mx-auto mb-[100px]">
                <div className="flex gap-[42px]">
                    {/* <div className="flex-shrink-0">
                        <CoursesLeftPanel selectedTopics={selectedTopics} onChange={setSelectedTopics} />
                    </div>*/}
                    <div className="flex-grow">
                        <CoursesListSection selectedTopics={selectedTopics} />
                    </div>
                </div>
            </div>
        </MainLayouts>
    );
}
